<template>
  <v-speed-dial v-model="active" fixed bottom right>
    <template v-slot:activator>
      <v-btn v-model="active" color="primary" dark fab>
        <v-icon v-if="active">mdi-close</v-icon>
        <v-icon v-else>add</v-icon>
      </v-btn>
    </template>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn @click="didTapItem('pdf')" fab small v-on="on">
          <v-icon color="disabled">insert_drive_file</v-icon>
        </v-btn>
      </template>
      <span>Arquivo PDF</span>
    </v-tooltip>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn @click="didTapItem('images')" fab small v-on="on">
          <v-icon color="disabled">image</v-icon>
        </v-btn>
      </template>
      <span>Galeria de imagens</span>
    </v-tooltip>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn @click="didTapItem('folder')" fab small v-on="on">
          <v-icon color="disabled">folder</v-icon>
        </v-btn>
      </template>
      <span>Pasta de arquivos</span>
    </v-tooltip>

    <v-tooltip left v-if="showsReorder">
      <template v-slot:activator="{ on }">
        <v-btn fab small v-on="on" @click="didTapItem('reorder')">
          <v-icon color="disabled">list</v-icon>
        </v-btn>
      </template>
      <span>Reordenar</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
export default {
  props: {
    value: Boolean,
    showsReorder: Boolean
  },
  computed: {
    active: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {
    didTapItem(name) {
      this.$emit("itemTapped", name);
    }
  }
};
</script>